import React, { useState } from 'react';
import { TFunction } from 'i18next';
import { adjustDeleteConfirmationPopupMessage, adjustDeleteConfirmationPopupSettings } from './MassDeleteButton';
import { Popup, PopupSettings } from 'components/common/popup/Popup';
import { Typography } from '@mui/material';
import { confirmationPopupProps } from '../index';

export default function useGridDeleteConfirmation(
    t: TFunction,
    confirmationSettings: confirmationPopupProps,
    onDeleteConfirmed: () => void,
    isRemove?: boolean,
    currentItemName?: string,
) {
    const [openConfirmation, setOpenConfirmation] = useState<boolean>(false);
    const confirmationMessage = adjustDeleteConfirmationPopupMessage({
        confirmation: confirmationSettings,
        t: t,
        isRemove: isRemove,
        currentItemName: currentItemName,
    });
    const confirmationPopupSettings: PopupSettings = adjustDeleteConfirmationPopupSettings({
        confirmation: confirmationSettings,
        t: t,
        isRemove: isRemove,
    });

    const ConfirmationPopup = () => (
        <Popup
            settings={confirmationPopupSettings}
            open={openConfirmation}
            t={t}
            onHide={() => setOpenConfirmation(false)}
            onConfirm={onDeleteConfirmed}
        >
            <Typography>{confirmationMessage}</Typography>
        </Popup>
    );

    return { ConfirmationPopup, setOpenConfirmation };
}
